import {Localizer} from "../../../infrastructure/localization/localizer";
import React from "react";
import {ValidationInput} from "../validation/components/validationInput";
import {nameof} from "ts-simple-nameof";
import {CreateFilterInputModel} from "../filter/createFilterInputModel";
import {FormikProps} from "formik";

export interface IFilterValidationInput {
    modalId: string,
    formik: FormikProps<CreateFilterInputModel>,
    overrideSubtleText?: string
}

export function FilterValidationInput({overrideSubtleText, ...props}: IFilterValidationInput) {
    const render = (
        <>
            <ValidationInput
                model={{
                    label: Localizer.titel(),
                    placeholder: Localizer.titelPlaceholder(),
                    htmlName: nameof<CreateFilterInputModel>(x => x.titel)
                }}
                inputId={nameof<CreateFilterInputModel>(x => x.titel) + props.modalId}
                formikProps={props.formik}
            />

            <span className={"small subtle caption margin-left-xs"}>
                {overrideSubtleText ?? Localizer.forloebOverviewPage_alleFiltreOprettesPrivat()}
            </span>
        </>
    )
    return <>{render}</>;
}
